import { Spinner } from "@blueprintjs/core";
import * as React from "react";

import QueryComponent from "core/api/QueryComponent";
import initialState from "core/reducers/initialState";
import Class from "../util/Class";
import { IPanelProps } from "./Panel";

export interface IQueryOptions {
	noResults: JSX.Element;
	loading: JSX.Element;
}

export interface IQueryRoot<T, P = any> {
	queryData: T;
	queryParams: P;
	queryState: {
		loading: boolean;
		errors?: any[] | null;
	};
}

type Params<T, configT> = (config: configT, pageParams: any, user: typeof initialState.user) => T;

export function QueryRoot<E, P, configT>(operationClazz: Class<E>, params?: Params<P, configT>): any {
	return (Panel: React.ComponentClass<IPanelProps<configT> & IQueryRoot<E, P>>) => {

		return (props: IPanelProps<any>) => {

			// pass page params from the panel decorator down to the params function
			// TODO use panel context so decorators can be applied in any order on a react component?
			const queryParams = typeof params === "function" ? (pageParams: any, user: any) => params(props.config, pageParams, user) : params;

			return (
				<QueryComponent.Root entity={operationClazz} args={queryParams}>
					{(args) => <Panel {...props} queryParams={args.params} queryData={args.data} queryState={{loading: args.loading}} />}
				</QueryComponent.Root>
			);
		};
	};
}



// WEBPACK FOOTER //
// ./src/core/decorators/QueryRoot.tsx